/*
 *
 * Login Type API Sagas
 *
 */

/* eslint-disable no-constant-condition */

import { put, call, take } from 'redux-saga/effects';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import { notAsked, loading, failure, success } from './actions';
import { MAKE_REQUEST } from './constants';
import apiRequest from './api';

export function* request(method, params) {
  try {
    // Set the status in the store to LOADING
    yield put(loading());
    // Make the request
    const results = yield call(apiRequest, method, params);
    // Save results to the store
    yield put(success(results));
  } catch (err) {
    let errorBody = err;
    if (isObject(err.response)) {
      if (isFunction(err.response.json)) {
        errorBody = yield err.response.json();
      }
      errorBody.status = err.response.status;
    }
    // The .json() method turns the response body into a promise.
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* idpCheckFlow() {
  yield put(notAsked());
  while (true) {
    // When MAKE_REQUEST is dispatched, make a request.
    const action = yield take(MAKE_REQUEST);
    yield call(request, 'POST', action.params);
  }
}

export default [idpCheckFlow()];



// WEBPACK FOOTER //
// ./src/services/LoginType/sagas.js